import { Host, h } from "@stencil/core";
import { mergeClassNames, hasSlot } from "@ace/web-components/dist_lib/utils";
import { getAceBettingBetButtonNames } from "./ace-betting-bet-button.get-names";
export class AceBettingBetButton {
    constructor() {
        this.type = 'default';
        this.layout = 'vertical';
        this.fullWidth = false;
        this.withError = false;
        this.selected = false;
        this.locked = false;
        this.inactive = false;
        this.sortIndicator = false;
    }
    componentWillLoad() {
        var _a;
        this.names = getAceBettingBetButtonNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
    }
    componentDidLoad() {
        this.handleError();
    }
    handleError() {
        if (this.withError) {
            this.triggerErrorEffect();
        }
    }
    handleIndicatorChange() {
        if (this.indicator) {
            this.resetIndicatorAnimation();
        }
    }
    triggerErrorEffect() {
        this.buttonElRef.classList.add(this.names.CLASS.____WITH_ERROR);
        setTimeout(() => {
            this.buttonElRef.classList.remove(this.names.CLASS.____WITH_ERROR);
        }, 1200);
    }
    resetIndicatorAnimation() {
        requestAnimationFrame(() => {
            if (this.indicatorRef) {
                this.indicatorRef.style.animation = 'none';
                this.indicatorRef.offsetHeight; // Force reflow
                this.indicatorRef.style.animation = '';
            }
        });
    }
    renderIndicator() {
        if (this.indicator === 'down') {
            return h("ace-icon", { id: this.names.ID.INDICATOR_DOWN, class: this.names.CLASS.INDICATOR_DOWN, color: 'surface-semantic--error', name: 'indicator-down', size: 'xs', ref: el => (this.indicatorRef = el) });
        }
        if (this.indicator === 'up') {
            return h("ace-icon", { id: this.names.ID.INDICATOR_UP, class: this.names.CLASS.INDICATOR_UP, color: 'surface-semantic--success', name: 'indicator-up', size: 'xs', ref: el => (this.indicatorRef = el) });
        }
        return null;
    }
    renderTendency() {
        return (h("div", { class: this.names.CLASS.TENDENCY }, h("slot", { name: 'tendency' })));
    }
    renderLabel() {
        return this.label ? (h("div", { id: this.names.ID.LABEL, class: this.names.CLASS.LABEL }, h("span", null, this.label))) : null;
    }
    renderOdd() {
        if (!this.odd && !this.indicator) {
            return null;
        }
        return (h("div", { class: this.names.CLASS.ODD }, hasSlot(this.hostElement, 'tendency') && (this.renderTendency()), h("div", { class: this.names.CLASS.ODD__LABEL }, this.odd), this.renderIndicator()));
    }
    renderButtonContent() {
        return this.locked ? (h("ace-icon", { id: this.names.ID.LOCKED_ICON, class: this.names.CLASS.LOCKED_ICON, name: 'lock-close', size: 'xs' })) : ([this.renderLabel(), this.renderOdd()]);
    }
    handleClick(e) {
        if (!this.locked && !this.inactive) {
            this.buttonClicked.emit(e);
            if (this.withError) {
                this.triggerErrorEffect();
            }
        }
    }
    getFinalCssClasses() {
        return mergeClassNames(this.names.CLASS.ROOT, {
            [this.names.CLASS.____LOCKED]: this.locked,
            [this.names.CLASS.____INACTIVE]: this.inactive && !this.locked,
            [this.names.CLASS.____SELECTED]: this.selected && !this.locked,
            [this.names.CLASS.____HORIZONTAL_LAYOUT]: this.layout === 'horizontal' || this.type === 'card', // card type is always horizontal
            [this.names.CLASS.____VERTICAL_LAYOUT]: this.layout === 'vertical' && this.type !== 'card',
            [this.names.CLASS.____CARD_TYPE]: this.type === 'card',
            [this.names.CLASS.____FULL_WIDTH]: this.fullWidth,
            [this.names.CLASS.____HAS_TENDENCY]: hasSlot(this.hostElement, 'tendency'),
        });
    }
    render() {
        const attrs = {
            'show-sort-indicator': !this.locked && this.sortIndicator ? '' : null,
            'selected': this.selected ? '' : null,
            'has-tendency': hasSlot(this.hostElement, 'tendency') ? '' : null,
        };
        return (h(Host, Object.assign({ key: '94743edfcdf35dfd19a66b7b9d001f5f0b6372c2' }, attrs), h("button", { key: '39d734bac43b96c2f7a04bd0202c89d3128cf990', onClick: e => this.handleClick(e), class: this.getFinalCssClasses(), disabled: this.locked || this.inactive, ref: el => (this.buttonElRef = el) }, this.renderButtonContent())));
    }
    static get is() { return "ace-betting-bet-button"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ace-betting-bet-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-betting-bet-button.css"]
        };
    }
    static get properties() {
        return {
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingBetButtonType",
                    "resolved": "\"card\" | \"default\"",
                    "references": {
                        "IAceBettingBetButtonType": {
                            "location": "import",
                            "path": "./ace-betting-bet-button.types",
                            "id": "src/components/ace-betting-bet-button/ace-betting-bet-button.types.ts::IAceBettingBetButtonType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "type",
                "reflect": false,
                "defaultValue": "'default'"
            },
            "layout": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingBetButtonLayout",
                    "resolved": "\"horizontal\" | \"vertical\"",
                    "references": {
                        "IAceBettingBetButtonLayout": {
                            "location": "import",
                            "path": "./ace-betting-bet-button.types",
                            "id": "src/components/ace-betting-bet-button/ace-betting-bet-button.types.ts::IAceBettingBetButtonLayout"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "layout",
                "reflect": false,
                "defaultValue": "'vertical'"
            },
            "fullWidth": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "full-width",
                "reflect": false,
                "defaultValue": "false"
            },
            "withError": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "with-error",
                "reflect": true,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "label",
                "reflect": false
            },
            "odd": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "odd",
                "reflect": false
            },
            "selected": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "selected",
                "reflect": true,
                "defaultValue": "false"
            },
            "locked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "locked",
                "reflect": false,
                "defaultValue": "false"
            },
            "inactive": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "inactive",
                "reflect": false,
                "defaultValue": "false"
            },
            "indicator": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingBetButtonIndicator",
                    "resolved": "\"down\" | \"none\" | \"up\"",
                    "references": {
                        "IAceBettingBetButtonIndicator": {
                            "location": "import",
                            "path": "./ace-betting-bet-button.types",
                            "id": "src/components/ace-betting-bet-button/ace-betting-bet-button.types.ts::IAceBettingBetButtonIndicator"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "indicator",
                "reflect": true
            },
            "sortIndicator": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "sort-indicator",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "buttonClicked",
                "name": "buttonClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "MouseEvent",
                    "resolved": "MouseEvent",
                    "references": {
                        "MouseEvent": {
                            "location": "global",
                            "id": "global::MouseEvent"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "hostElement"; }
    static get watchers() {
        return [{
                "propName": "withError",
                "methodName": "handleError"
            }, {
                "propName": "indicator",
                "methodName": "handleIndicatorChange"
            }];
    }
}
//# sourceMappingURL=ace-betting-bet-button.js.map
